import { Navigate } from "Navigation/Navigate";
import Error404Page from "Pages/Error/Error404Page";
import { getAppUrl } from "Utils/UrlUtils";
import type { ReactNode } from "react";
import type { RouteProps } from "react-router-dom";

type Props = {
  allowedRoles: ReadonlyArray<string>;
  userAccessRole?: string | null;
  children: ReactNode;
  protectionMode?: "404" | "sign-in";
} & RouteProps;

export const RoleAuthorizedRoute = ({
  allowedRoles,
  userAccessRole,
  children,
  protectionMode = "sign-in",
}: Props) => {
  const appUrl = getAppUrl();
  const isAuthorized = userAccessRole
    ? allowedRoles.includes(userAccessRole)
    : false;

  if (!isAuthorized) {
    if (protectionMode === "404") {
      return <Error404Page />;
    }

    // Don't pass location object in state - it's not serializable
    return (
      <Navigate to={appUrl("sign-in")} state={{ from: location.toString() }} />
    );
  }

  return <>{children}</>;
};
